import { gql } from 'graphql-request'

const getSearchArticlesDownloads = gql`
  query getSearchResults(
    $search: String
    $lang: [Locale!]!
    $assetLocales: [Locale!]!
  ) {
    articles(where: { _search: $search }, locales: $lang) {
      id
      title
      slug
      excerpt
      isHearingStory
      tags {
        id
        title
      }
      topics {
        title
        slug
      }
      updatedAt
      image(locales: $assetLocales) {
        src: url(transformation: { document: { output: { format: webp } } })
        src_webp: url(
          transformation: { document: { output: { format: webp } } }
        )
        alt
      }
    }
    download(where: { id: "ckwdar72onewk0a01m05ql4q8" }) {
      id
      title
      type: __typename
      items {
        id
        title
        text: caption
        alt
        thumbnail: url(
          transformation: {
            document: { output: { format: png } }
            image: { resize: { width: 200, height: 290, fit: crop } }
          }
        )
        thumbnailWebp: url(
          transformation: {
            document: { output: { format: webp } }
            image: { resize: { width: 200, height: 290, fit: crop } }
          }
        )
        url
      }
    }
  }
`
export default getSearchArticlesDownloads
